import * as React from 'react'
import { Helmet } from 'react-helmet'

import NewBrandDashboard from '../BrandDashboard'
import Payments from './Payments/Payments'

interface BrandDashboardPaymentsProps {
  match?: { params: { id: string } }
  brandOrderUuid?: string
}

const BrandDashboardPayments: React.FC<BrandDashboardPaymentsProps> = ({ match }) => {
  const brandId = match && match.params.id

  React.useEffect(() => {
    document.body.className = ''
    document.body.classList.add('billing')
    return () => {
      document.body.className = ''
      document.body.classList.add('billing')
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>Payments - 90 Seconds</title>
      </Helmet>
      <NewBrandDashboard brandId={brandId} children={<Payments />} activeButton={6} />
    </>
  )
}

export default BrandDashboardPayments



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardPayments/BrandDashboardPayments.tsx